import LazyHydrate from 'react-lazy-hydration'

import DidNotFindBlock from './components/DidNotFindBlock'

const HelpCenterLayout = ({ children }) => {
  return (
    <>
      {children}

      <LazyHydrate whenVisible>
        <DidNotFindBlock />
      </LazyHydrate>
    </>
  )
}

export default HelpCenterLayout
